<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="data().title" widgetType="job">
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="work"
      color="colorIconEvaluationDefault"
      background="colorBgEvaluationLowDefault"
    />
    <div class="text">
      <span class="title">{{ data().title }}</span>
      <span class="meta">
        <span [class]="['status-dot', 'status-dot--' + data().status]"></span>
        <span>{{ statusLabel() }}</span>
        @if (!!data().candidatesCount) {
          <span class="sep">&bull;</span>
          <span>{{
            'tlc.tellent_assistant.list_item.candidates_count'
              | translate: { count: data().candidatesCount }
          }}</span>
        }
        @if (data().location; as loc) {
          <span class="sep">&bull;</span>
          <span>{{ loc }}</span>
        }
      </span>
    </div>
  </div>
</rt-assistant-list-card>
